import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/sales-rm-quarter-targets';
const TEAM_BASE = '/api/v1/admin/mtd-business-report/team-members';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const salesRmQuarterTargetService = {
  listTeamMembers: async () => {
    const response = await apiClient.get(TEAM_BASE);
    return unwrap(response.data);
  },

  listTargets: async ({ fyStartYear, quarter }) => {
    const response = await apiClient.get(BASE, {
      params: { fy_start_year: fyStartYear, quarter },
    });
    const data = unwrap(response.data);
    return data?.targets ?? [];
  },

  upsertTargets: async (targets) => {
    const response = await apiClient.put(BASE, { targets });
    return response.data;
  },
};

export default salesRmQuarterTargetService;
